const lang_zh = {
    "index01": "RWA-ART是一个集古董发射台、IDO、古董交割的综合性创新平台",
    "index011": "RWA-ART是一个集古董发射台、",
    "index012": "IDO、古董交割的综合性创新平台",
    "index02": "通过 RWA平台，你可以将你的古董资产代币化或者使用代币来交割古董",
    "index03": "预计",
    "index04": "开始",
    "index05": "结束",
    "index06": "当前价格",
    "index07": "评估价",
    "index08": "进行中",
    "index09": "待开始",
    "index10": "已结束",
    "index11": "提供技术支持的伙伴",
    "index12": "已发射",
    "index13": "构建BSC链上一站式RWA艺术品代币发行平台，支持古董拍得者创建代币和投资者参与交易",



    "toastShowType01": "确认钱包中的交易...",
    "toastShowType02": "交易已提交.",
    "toastShowType03": "操作成功!",
    "toastShowType04": "失败!",
    "toastShowType05": "操作已取消.",
    "view": "查看",
    "account": "账户",
    "change": "切换",
    "disconnect": "断开",
    "caddr": "复制地址",
    "viewbro": "在浏览器中查看",
    "connected": "已连接",
    "conwall": "连接钱包",
    "gmai": "购买",
    "gmcg": "购买成功",
    "gmsb": "购买失败",
    "jgcg": "交割成功",
    "jgsb": "交割失败",
    "home": "首页",
    "wkuang": "挖矿",
    "scheng": "商城",
    "dbjj": "代币经济",
    "wdkk": "我的矿卡",
    "xlt": "路线图",
    "tgjj": "推广奖励",
    "xliang": "限量",
    "syu": "剩余",
    "jge": "价格",
    "sl": "数量",
    "fe": "份",
    "bpishu": "白皮书",
    "bhao": "编号",
    "zrang": "转让",
    "jsdz": "接收地址",
    "qux": "取消",
    "qrzr": "确定转让",
    "tgjl": "推广奖励",
    "wdjl": "我的奖励",
    "wdjlze": "我的奖励总额",
    "wdyqlj": "我的邀请链接",
    "qxljqb": "请先连接钱包",
    "yqjl": "邀请记录",
    "zyqs": "总邀请数",
    "xuhao": "序号",
    "dizi": "地址",
    "jlje": "奖励金额",
    "sjian": "时间",
    "jzz": "加载中...",
    "zwsj": "暂无数据！",
    "fzcg": "复制成功！",
    "myfzrhnr": "未复制任何内容！",
    "jqqd": "敬请期待",
    "sqsb": "授权失败！",
    "wlljcw": "网络连接错误！",
    "qsrzcdjsdz": "请输入正确的接收地址！",
    "ystxz": "原始通行证",
    "bqsy": "版权所有 ©2025 RWA.ART 公司 - 保留所有权利",
    "yqpybzqyj": "邀请朋友赚取佣金！",
    "pro1": "高达",
    "pro2": "10%",
    "pro3": "返佣！",
    "mchygmkj": "每次好友购买矿机均可获得奖励。",
    "gmbuc": "买入BUCOIN",
    "": "",
}
export default lang_zh;
